<template>
	<div full-height>
		<v-toolbar flat fixed>
			<v-toolbar-side-icon @click="fn_confirmBack"><v-icon>arrow_back</v-icon></v-toolbar-side-icon>
		    <v-toolbar-title class="white--text">Set Auto Backup Drive</v-toolbar-title>
		</v-toolbar>

		<div class="hasToolbar">
			<v-alert type="info" :value="msgAlert">
				Drive setup is a mandatory step. To keep your data safe is our first priority and with this step your business data will be secure on your drive.
			</v-alert>

			<v-card noshadow>
				<v-card-text>

					<div center-align>
		            	<p class="title primary-color" style="line-height:28px !important">
		            		Choose your Google Account
		            		<!-- Setup a google drive for <span dark-opacity-color>
		            			<strong>{{$root.CurrentBusiness.BusinessName}}</strong>
		            			Abc Corp Ltd.
		            		</span> 
		            			to backup your business data -->
		            	</p><br>

		            	<div style="width: 68px;height: 68px;border-radius: 50%;background: #F0F0F0;margin: auto;padding: 12px">
		            		<v-icon class="primary-color" style="font-size:42px">person</v-icon>
		            	</div><br>

		            	<p class="title grey-color" style="line-height:28px !important">
		            		Sign in to backup your data to your Google Drive
		            	</p><br>

		            	<div>
		            		<v-btn color="primary" @click="fn_showGoogleAccounts">
			               		Sign IN
			               	</v-btn>
		            	</div><br>

		            	<p class="title grey-color font12" style="line-height:20px !important">
		            		BY CLICKING ON SIGN IN, YOU AGREE THAT BIZOPS APP DOES NOT GUARANTEE, REPRESENT, OR WARRANT THAT YOUR USE OF THE GOOGLE DRIVE BAKCUP OPTION WILL BE UNINTERRUPTED OR ERROR-FREE, AND YOU EXPRESSLY AGREE THAT YOUR USE OF, OR INABILITY TO USE, THE GOOGLE DRIVE BACKUP OPTION IS AT YOUR SOLE RISK
		            	</p><br>
		            </div>

				</v-card-text>
			</v-card>

			<v-list-tile @click.native="fn_watchHelpVideo" class="video-link-tile full-width" style="position: fixed;bottom: 0;" avatar>
				<v-list-tile-content>
					<v-list-tile-title font14>How to set auto backup drive in BizOps App?</v-list-tile-title>
					<v-list-tile-sub-title font12 primary-color>Watch Video <v-icon class="ml-1 font14" style="border-radius: 50%;background: rgb(66, 165, 245);color: #fff !important;">chevron_right</v-icon></v-list-tile-sub-title>
				</v-list-tile-content>
			</v-list-tile>
		</div>

		<!-- <dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod"></dialog-confirmation> -->
		<dialog-confirmation ref="ref_dialogConfirmation" :header="confirmationHeader" :confirmationMessage="confirmationMessage" :actionMethod="actionMethod" :cancelMethod="cancelMethod" :cancelBtnText="cancelBtnText" :okBtnText="okBtnText"></dialog-confirmation>

		<!-- <dialog-permission ref="ref_dialogPermission"></dialog-permission> -->

	</div>
</template>

<script>

const dialogjs =  require('../masters/forms/dialog').dialogjs;
import dialogConfirmation from '../dialogs/dialog_confirmation'

// import dialogPermission from '../dialogs/dialog_permission';

	export default{
		data(){
			return{
				loading:false,
				msgAlert:false,
				confirmationMessage:null,
				confirmationHeader:null,
				actionMethod:null,
				dialogStorageId:null,
				cancelMethod:null,
				okBtnText:null,
				cancelBtnText:null,
			}
		},
		components:{
			'dialog-confirmation': dialogConfirmation,
			// 'dialog-permission': dialogPermission,
		},
		methods:{

			fn_showGoogleAccounts: function(){
				if(!navigator.onLine){
					this.showToast('Internet not available');
					return;
				}
				
				var self = this;
				AndroidRoutingTest.revokeAccount();
		  		this.getData('ShowGoogleAccounts', null, 
					{
						onSuccess: function(response){
				            console.log(response);
				            self.$root.fn_checkStoragePermission(function(){
				            	self.showLoading('Please wait...');
			                    self.$root.fn_getAuthToken(function(token){
									self.fn_setBackupDrive(response, token);
								})
			                });
				        }, 
				        onError: function(error){
				        	self.msgAlert = true;
				          	console.log(error);
				        }
					}
		        );
			},

			fn_setBackupDrive: function(backupAccountId, token){
				if(!navigator.onLine){
					this.showToast('Internet not available');
					this.hideLoading();
					return;
				}

				let self = this;
				let postObj = {};
				postObj.BusinessID = this.$root.CurrentBusiness.BusinessID,
				postObj.DataDriveLocation = backupAccountId;
				postObj.token = token;
				postObj.RequestID = null;

				if(!token){
					console.log("Token not found");
					this.showToast("Something went wrong. Try again!.");
					return;
				}

		  		this.postServerData('SetDataDrive', postObj, 
					{
						onSuccess: function(response){
				            self.fn_resetDatabase(backupAccountId);
				        }, 
				        onError: function(error){
				          	console.log(error);
				          	self.hideLoading();
				          	AndroidRoutingTest.revokeAccount();
				          	if(typeof JSON.parse(error) == 'object'){
					          	let response = JSON.parse(error);
					          	self.showToast(response.Message);
					        }
				        }
					}
		        );
			},

			fn_resetDatabase: function(backupAccountId){
				let self = this;
		  		this.getData('ResetDatabase', this.$root.CurrentBusiness.BusinessID, 
					{
						onSuccess: function(response){
				            console.log(response);
				            let status = JSON.parse(response);
				            if(status!=null){
				            	self.showToast('Backup drive set up complete');
				            	self.$root.CurrentBusiness.DataDrive = backupAccountId;
				            	self.fn_prepareDataToBackup();
				            	// self.fn_confirmBack();
				            }
				            else{
				            	self.showToast("Something went wrong. Try again");
				            }
				            // self.hideLoading();
				        }, 
				        onError: function(error){
				          	console.log(error, 'error in reset database');
				          	self.showToast("Something went wrong. Try again");
				        }
					}
		        );
			},


			// backup data after setup drive
			fn_prepareDataToBackup: function(){

	            if(!navigator.onLine){
	                this.showToast('Internet not available');
	                return;
	            }

	            this.$root.uploadStatus = 0;

	            let self = this;
	            this.showToast('Preparing data for backup');
	            this.getData('PrepareBackupData', this.$root.CurrentBusiness.BusinessID, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.fn_reopenDatabase();
	                    },
	                    onError: function(error){
	                        console.log(error);
	                        self.hideLoading();
	                        self.showToast('Something went wrong. Try again');
	                    }
	                }
	            );
	        },

	        // reopening db as puran closing db before preparing data for backup
	        fn_reopenDatabase: function(){
	            let self = this;
	            this.getData('ReopenDataBase', this.$root.CurrentBusiness.BusinessID, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.fn_backupData();
							if(self.$route.query.goback){
								self.fn_confirmBack();
							}
	                        self.hideLoading();
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                        self.showToast('Something went wrong. Try again');
	                    }
	                }
	            );
	        },

	        fn_backupData: function(){
	            var self = this;
	            this.$root.backupInProgress = true;
	            this.fn_confirmBack();
	            this.getData('BackupData', this.$root.CurrentBusiness.BusinessID, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.$root.backupInProgress = false;
	                        self.$root.uploadStatus = null;
	                    },
	                    onError: function(error){
	                        console.log(error);
	                        self.$root.backupInProgress = false;
	                        self.$root.uploadStatus = null;
	                        self.showToast('Something went wrong. Try again');
	                    }
	                }
	            );
	        },


			// removing database before going back
			fn_removeBusinessData: function(){
	            let self = this;
	            this.getData('RemoveBusinessData', this.$root.CurrentBusiness.BusinessID, 
	                {
	                    onSuccess: function(response){
	                        console.log(response);
	                        self.fn_quitConfirmation();
	                    }, 
	                    onError: function(error){
	                        console.log(error);
	                    }
	                }
	            );
	        },

			fn_openDialogWeb: function (platform, name, ref) {

				let scroll_y = window.scrollY;
				this.fn_fixBackgroundScroll();

				var dialogObj = {};
				dialogObj.tagId = this.guidWeb();
				dialogObj.formId = this.formId;
				dialogObj.name = name;
				dialogObj.ref = ref;
				dialogObj.data = null;
				dialogObj.platform = platform;

				dialogObj.scrollPosition = {};
				dialogObj.scrollPosition.x = 0;
				dialogObj.scrollPosition.y = scroll_y;

				dialogjs.fn_pushDialogInStack(this.dialogStorageId, dialogObj, this);

				let self = this;

				this.$refs[ref].openDialogWeb();
			},

			fn_openDialogConfirmation: function(){
				this.fn_openDialogWeb('web', 'Confirmation', 'ref_dialogConfirmation')
			},

			fn_closeDialog: function () {
				dialogjs.fn_checkAndCloseOpenDialogs(this);
			},

			fn_quit: function(){
				var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
		    	if(dialogData && dialogData.length){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
				}
				else{
					this.confirmationMessage = null;
					this.confirmationHeader = "Quit Drive Setup?";
					this.actionMethod = this.fn_confirmBack;
					this.cancelMethod = null;
					this.okBtnText = null;
					this.cancelBtnText = null;
					this.fn_openDialogConfirmation();
				}
			},

			fn_confirmBack: function(){
				if(this.$route.query.isdialogopen){
					localStorage.setItem('closeDialog', 1);
				}
				// this.$router.go(-1);
				var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
		    	if(dialogData && dialogData.length){
					dialogjs.fn_checkAndCloseOpenDialogs(this);
				}
				else if(this.$route.query.t_count && this.$route.query.t_count >= 10 && !this.$root.CurrentBusiness.DataDrive){
					this.confirmationHeader = "Set Auto Data Backup?";
					this.confirmationMessage = "<div class='pl-3 pr-3 pt-2 pb-2 mb-2' style='background:#fff3cd;color:#856404;margin:0px -16px;'><p class='mb-1 font16 font-medium'>Warning: You could lose your data, if you didn’t configure auto backup and changed device.</p></div><p class='mb-1 font16'>Are you sure you do not want to set auto data backup?</p>";
					this.actionMethod = this.fn_driveAction;
					this.cancelMethod = this.exitApp;
					this.cancelBtnText = "Exit App";
					this.okBtnText = "Setup Now";
					this.fn_openDialogConfirmation();
				}
				else{
					this.$router.go(-1);
				}
			},

			fn_driveAction: function(){
				this.fn_closeDialog();
				setTimeout(() => {
					this.fn_showGoogleAccounts();
				}, 300);
			},

			fn_watchHelpVideo: function(){
				this.$root.fn_openExternalUrl('https://www.youtube.com/watch?v=Swi0dXEjHKk&list=PLlyT7aaJmsIsicHYhxa_JWGHA0RK41yuh');
			}

			// fn_openPermissionDialog: function(permissionType){
		    //     this.$root.permissionType = permissionType;
		    //     this.fn_openDialogWeb('web', 'Permission', 'ref_dialogPermission');
		    // },
		},
		mounted: function(){
			this.dialogStorageId = this.guidWeb();
			window.js_globals.fn_onBackPress = this.fn_confirmBack;
			// window.js_globals.fn_openPermissionDialog = this.fn_openPermissionDialog;
		},
		beforeRouteLeave (to, from, next) {
	    	var dialogData = JSON.parse(localStorage.getItem(this.dialogStorageId));
	    	if(dialogData && dialogData.length){
				dialogjs.fn_checkAndCloseOpenDialogs(this);
				next(false);
			}
			else{
				next();
			}
	    }
	}
</script>


// WEBPACK FOOTER //
// src/components/registration/set_backup_drive.vue